import { useState } from "react";
import Navbar from "../components/common/Navbar";
import "../styles/ComparePage.css";
import { checkInputUtility } from "../utils/checker/checkerInput";

// Reusable textarea component
const TextareaField = ({ label, value, onChange, isReadOnly = false, htmlContent }) => (
  <div className="my-4">
    <h5 className="compareTitle">{label}</h5>
    {!isReadOnly ? (
      <textarea
        className="form-control compareTextarea mt-4"
        rows="5"
        value={value}
        onChange={onChange}
      />
    ) : (
      <div
        className="form-control compareTextarea mt-4 comparedResult"
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    )}
  </div>
);

// Result summary panel
const ResultSummary = ({ accuracy, errors, onCheck, onReset, disabled }) => (
  <div className="summaryBox py-3">
    <h5 className="compareTitle mb-4">Result</h5>

    <p>
      <strong className="resultNames">Accuracy:</strong> {accuracy !== null ? `${accuracy}%` : "-"}
    </p>

    <p>
      <strong className="resultNames">Errors:</strong> {errors}
    </p>

    <button className="compareButtons check w-100 mt-4 mb-2" onClick={onCheck} disabled={disabled}>
      Check
    </button>

    <button className="compareButtons reset w-100 mt-3" onClick={onReset}>
      Reset
    </button>
  </div>
);

const ComparePage = () => {
  const [expected, setExpected] = useState("");
  const [attempt, setAttempt] = useState("");
  const [resultHTML, setResultHTML] = useState(null);
  const [accuracy, setAccuracy] = useState(null);
  const [errors, setErrors] = useState(0);

  const handleCheck = () => {
    const { calculatedAccuracy, groupedHTML, errorCount } = checkInputUtility(expected, attempt);

    setResultHTML(groupedHTML);
    setAccuracy(calculatedAccuracy);
    setErrors(errorCount);
  };

  const handleReset = () => {
    setExpected("");
    setAttempt("");
    setResultHTML(null);
    setAccuracy(null);
    setErrors(0);
  };

  return (
    <div>
      <Navbar />

      <div className="container-fluid containerDesktop">
        <div className="mt-4 title">Comparison</div>

        <div className="container containerDesktop mt-4 compare-wrapper">
          <div className="row">
            {/* Input and comparison area */}
            <div className="col-lg-8 col-12">
              <TextareaField
                label="Expected Input"
                value={expected}
                onChange={(e) => setExpected(e.target.value)}
              />

              <TextareaField
                label={resultHTML ? "Compared Result" : "Attempt Input"}
                value={attempt}
                onChange={(e) => setAttempt(e.target.value)}
                isReadOnly={!!resultHTML}
                htmlContent={resultHTML}
              />
            </div>

            {/* Result summary */}
            <div className="col-lg-4 col-12 mt-4 mt-lg-0">
              <ResultSummary
                accuracy={accuracy}
                errors={errors}
                onCheck={handleCheck}
                onReset={handleReset}
                disabled={!expected || !attempt}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparePage;
